// Turbo Drive — SPA-style navigation; Vue mounts/unmounts on turbo:load / turbo:before-render
import "@hotwired/turbo-rails"

// Flowbite — re-initialise on every Turbo navigation
import { initFlowbite } from 'flowbite'
document.addEventListener('turbo:load', () => initFlowbite())

// Ahoy analytics
import ahoy from 'ahoy.js'

// Rich text editor
import 'trix'
import '@rails/actiontext'

// quill and canvas-confetti are imported by the components that use them (quill_editor,
// HellobarRichTextInput, vue_confetti), so they load with those pages, not on every page.

window.__VUE_PROD_DEVTOOLS__ = false

function getCookie(cookieName) {
  const cookies = document.cookie.split(';')
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=')
    if (name === cookieName) return decodeURIComponent(value)
  }
  return null
}

document.addEventListener('turbo:load', function () {
  try {
    if (getCookie('log_detailed_ahoy_devents') === 'true') {
      ahoy.trackView()
      ahoy.trackClicks('a, button, input[type=submit]')
      ahoy.trackSubmits('form')
      ahoy.trackChanges('input, textarea, select')
    }
  } catch (error) {
    console.log(error)
  }

  // Close timezone dropdown on outside click
  document.addEventListener('click', function (event) {
    const timezoneDropdown = document.getElementById('searchDropdown')
    const timezoneButton = document.getElementById('searchButton')
    if (timezoneDropdown && !timezoneDropdown.classList.contains('hidden')) {
      if (!timezoneDropdown.contains(event.target) && !timezoneButton.contains(event.target)) {
        timezoneButton.click()
      }
    }
  })
})

// Vue application (mounts on turbo:load, unmounts on turbo:before-render)
import '../components/main.js'
